import { TranslationWaterAdditionByTravelMessages } from "../interfaces/waterAdditionByTravelMessages";

const waterAdditionByTravelMessages: TranslationWaterAdditionByTravelMessages = {
  "waterAdditionByTravel.title": "Adición de Agua por Viaje",
  "waterAdditionByTravel.waterAdditionByTravel": "Adición de Agua por Viaje",
  "waterAdditionByTravel.filterTitle": "Filtrar Adiciones de Agua por Viaje",
  "waterAdditionByTravel.fleetCode": "Flota",
  "waterAdditionByTravel.licensePlate": "Placa",
  "waterAdditionByTravel.startDate": "Fecha de Inicio",
  "waterAdditionByTravel.finishDate": "Fecha de Fin",
  "waterAdditionByTravel.driver": "Conductor",
  "waterAdditionByTravel.document": "Doc.",
  "waterAdditionByTravel.volume": "Volumen",
  "waterAdditionByTravel.reassignedPostDischarge": "Post-descarga (viaje anterior)",
  "waterAdditionByTravel.originTravelDoc": "Doc. viaje de origen",
  "waterAdditionByTravel.preDischarge": "Pre-descarga (L)",
  "waterAdditionByTravel.postDischarge": "Post-descarga (L)",
  "waterAdditionByTravel.noDataFound": "No se encontraron adiciones de agua para el período seleccionado",
  "waterAdditionByTravel.minWater": "Agua Mín.",
  "waterAdditionByTravel.maxWater": "Agua Máx.",
  "waterAdditionByTravel.waterTotal": "Agua Total (L)",
  "waterAdditionByTravel.waterAdditionTitle": "Adición de Agua",
  "waterAdditionByTravel.analyticTabTitle": "Analítico",
  "waterAdditionByTravel.syntheticTabTitle": "Sintético"
};

export const messages = waterAdditionByTravelMessages;
